export const DOMAIN = 'dataMap';
